import { render, staticRenderFns } from "./Recomendation.vue?vue&type=template&id=265a37e2&scoped=true"
import script from "./Recomendation.vue?vue&type=script&lang=js"
export * from "./Recomendation.vue?vue&type=script&lang=js"
import style0 from "./Recomendation.vue?vue&type=style&index=0&id=265a37e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a37e2",
  null
  
)

export default component.exports